// @flow
import ScrollbarsWShadow from './scrollbars-w-shadow';

export default ScrollbarsWShadow;
